import Remove from './Remove.js';
export default Remove;
